import { PRODUCT_ATTRIBUTES_FILTERS, PRODUCT_VARIANT_FILTERS, ESSENTIAL_OILS_FILTERS } from '@/types/FiltersConst';
import sortingConst from '@/types/SortingConst';

export const PRICE_PARAM_REGEXP = /range \((\d+) to (\d+)\)/;
export const LETTER_PARAM_REGEXP = /^[A-Z]$/;

enum QueryParamNames {
  page = 'page',
  sort = 'sort',
  price = 'price',
  letter = 'letter',
}

const RLPQueryParams = {
  names: [QueryParamNames.page, QueryParamNames.sort],
  values: {
    [QueryParamNames.sort]: sortingConst.RLPSortingOptions,
  },
};
const ALPQueryParams = {
  names: [QueryParamNames.page, QueryParamNames.sort],
  values: {
    [QueryParamNames.sort]: sortingConst.ALPSortingOptions,
  },
};
const EOGLPQueryParams = {
  names: [QueryParamNames.page, QueryParamNames.letter, ...ESSENTIAL_OILS_FILTERS],
  values: {
    [QueryParamNames.letter]: LETTER_PARAM_REGEXP,
  },
};
const PLPQueryParams = {
  names: [QueryParamNames.page, QueryParamNames.sort, ...PRODUCT_ATTRIBUTES_FILTERS, QueryParamNames.price],
  values: {
    [QueryParamNames.sort]: sortingConst.PLPSortingOptions,
    [QueryParamNames.price]: PRICE_PARAM_REGEXP,
  },
};
const searchQueryParams = {
  names: [QueryParamNames.page, QueryParamNames.sort, ...PRODUCT_ATTRIBUTES_FILTERS, QueryParamNames.price],
  values: {
    [QueryParamNames.sort]: sortingConst.SearchSortingOptions,
    [QueryParamNames.price]: PRICE_PARAM_REGEXP,
  },
};

// for PDP parameter "page" only for EoGuide for FR
const PDPQueryParams = {
  names: [...PRODUCT_VARIANT_FILTERS, QueryParamNames.page],
};

export default {
  RLPQueryParams,
  ALPQueryParams,
  EOGLPQueryParams,
  PLPQueryParams,
  searchQueryParams,
  PDPQueryParams,
};
